<template>
  <div class="loadingwrapper" ref="loading">
    <div class="loading" :style="{ height: `${altura}px`, width: `${largura}px` }" v-if="!inModal">
      <img src="static/img/spinner.gif" class="spinner" :style="{ height: `${alturaImg}px`, width: `${larguraImg}px` }"><br>
    </div>
    <div class="loadingModal" :style="{ height: `${altura}px`, width: `${largura}px` }" v-if="inModal">
      <img src="static/img/spinner.gif" class="spinner" :style="{ height: `${alturaImg}px`, width: `${larguraImg}px` }"><br>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      altura: 0,
      largura: 0,
      alturaImg: 200,
      larguraImg: 200
    }
  },

  props: {
    inModal: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  /* computed: {
    altura () {
      if (this.$refs.loading) {
        return this.$refs.loading.offsetParent.offsetHeight
      }
    },
    largura () {
      if (this.$refs.loading) {
        return this.$refs.loading.offsetParent.offsetWidth
      }
    }
  }, */

  mounted () {
    if (this.inModal) {
      this.altura = this.$refs.loading.parentElement.offsetHeight + 127
      this.largura = this.$refs.loading.parentElement.offsetWidth
    } else {
      this.altura = this.$refs.loading.parentElement.offsetHeight
      this.largura = this.$refs.loading.parentElement.offsetWidth
    }
    if (this.altura < this.alturaImg) {
      this.alturaImg = this.altura
      this.larguraImg = this.altura
    }
  }
}
</script>

<style scope>

.loading {
  position: absolute;
  top: -20px;
  left: -20px;
  background:rgba(255, 255, 255, 0.85);
  z-index: 10;
  display: flex;
}

.loadingModal {
  position: absolute;
  top: -75px;
  left: -16px;
  background:rgba(255, 255, 255, 0.85);
  z-index: 10;
  display: flex;
}

.loadingwrapper {
  position: relative;
}

.spinner {
  height: 200px;
  width: 200px;
  margin: auto;
}

/* .images {
  position: relative;
  display: inline-block;
}

.images p {
  position: absolute;
  width: 100%;
  text-align: center;
  bottom: 0;
  left: 0;
} */

</style>
